import { render, staticRenderFns } from "./_SupportHead.vue?vue&type=template&id=53e659f5&scoped=true"
import script from "./_SupportHead.vue?vue&type=script&lang=js"
export * from "./_SupportHead.vue?vue&type=script&lang=js"
import style0 from "./_SupportHead.vue?vue&type=style&index=0&id=53e659f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e659f5",
  null
  
)

export default component.exports